<template>
  <DefaultNavigation :logo="logo">
    <!-- slot to fill buttons -->
    <slot />
  </DefaultNavigation>
</template>

<script>
import DefaultNavigation from '@/components/DefaultNavigation'
import { mapGetters } from 'vuex'

export default {
  components: { DefaultNavigation },

  props: {
    logo: { type: Object, default: null },
  },

  computed: mapGetters({ featureIsEnabled: 'app/featureIsEnabled' }),
}
</script>
